import { render, staticRenderFns } from "./SaleList.vue?vue&type=template&id=4310df08&scoped=true&"
import script from "./SaleList.vue?vue&type=script&lang=js&"
export * from "./SaleList.vue?vue&type=script&lang=js&"
import style0 from "./SaleList.vue?vue&type=style&index=0&id=4310df08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310df08",
  null
  
)

export default component.exports